<ng-container *transloco="let t">
  <div class="admin-card">
    <app-admin-actions-header (onExportToPdf)="downloadOrganisers('pdf')" (onExportToXls)="downloadOrganisers('xlsx')">
      <div slot="leadingWidgets" class="d-flex flex-column flex-md-row">
        <app-search-rounded [name]="name" [placeholder]="t('explore.search')"
                            (searchEmitter)="handleSearchInput($event)"></app-search-rounded>
      </div>
      <div slot="trailingWidgets">
        <div class="pe-3">
          <app-rounded-button [label]="t('organiser.list.add.new')" (onClick)="onAddOrganiser()"><i
            class="bi bi-plus-circle pe-2"></i></app-rounded-button>
        </div>
      </div>
    </app-admin-actions-header>
    @if (filteredOrganisers.length > 0) {
      <div>
        <div class="table-responsive d-xl-block d-none">
          <app-sortable-table cssClass="table dark-header table-last-row-no-border" infinite-scroll
                              [infiniteScrollDistance]="4"
                              [items]="filteredOrganisers" [infiniteScrollThrottle]="environment.fullTextSearchDelay">
            <thead>
            <tr>
              <th scope="col" [sortBy]="['name']">{{ t('organiser.details.name') }}
              </th>
              <th scope="col" [sortBy]="['website']">{{ t('organiser.details.web') }}
              </th>
              <th scope="col" class="icon-column-width"></th>
            </tr>
            </thead>
            <tr app-table-header-separator></tr>
            <tbody>
              @for (organiser of filteredOrganisers;track trackByFn) {
                <tr>
                  <td class="center-align">{{ organiser.name }}</td>
                  <td class="center-align">
                    <a class="text-black fw-semibold" href="{{ organiser.website }}"
                       target="_blank">{{ organiser.website }}</a>
                  </td>
                  <td class="text-end center-align">
                    <span class="edit-icon" (click)="onEditOrganiser(organiser)"><i
                      class="fas fa-pencil-alt"></i></span>
                  </td>
                </tr>
              }
            </tbody>
          </app-sortable-table>
        </div>

        <!--      Mobile table-->
        @for (organiser of filteredOrganisers;track trackByFn;let isLast = $last) {
          <div class="d-block d-xl-none">
            <div class="d-flex flex-column mobile-table-row" (click)="onEditOrganiser(organiser)"
                 [class.isLastRow]="isLast">
              <div>
                {{ organiser.name }}
              </div>
              <div class="break-word">
                <small>{{ organiser.website }}</small>
              </div>
            </div>
          </div>
        }
      </div>
    } @else {
      <div class="pt-2 pb-4">
        <app-empty-state/>
      </div>
    }
    @if (showFabButton && (organisers?.length ?? 0) > 0) {
      <div (click)="scrollToTop()" class="scroll-to-top">
        <i class="bi bi-arrow-up"></i>
      </div>
    }
  </div>
</ng-container>
